import { render, staticRenderFns } from "./subsector.vue?vue&type=template&id=6f5c9f33&scoped=true"
import script from "./subsector.vue?vue&type=script&lang=js"
export * from "./subsector.vue?vue&type=script&lang=js"
import style0 from "./subsector.vue?vue&type=style&index=0&id=6f5c9f33&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f5c9f33",
  null
  
)

export default component.exports